module.exports = __webpack_public_path__ + "static/media/warningSign.de561c01.svg";